const Country = [
  { name: "Afghanistan", code: "Afghanistan" },
  { name: "Albania", code: "Albania" },
  { name: "Algeria", code: "Algeria" },
  { name: "Andorra", code: "Andorra" },
  { name: "Angola", code: "Angola" },
  { name: "Antigua and Barbuda", code: "Antigua and Barbuda" },
  { name: "Argentina", code: "Argentina" },
  { name: "Armenia", code: "Armenia" },
  { name: "Australia", code: "Australia" },
  { name: "Austria", code: "Austria" },
  { name: "Azerbaijan", code: "Azerbaijan" },
  { name: "Bahamas", code: "Bahamas" },
  { name: "Bahrain", code: "Bahrain" },
  { name: "Bangladesh", code: "Bangladesh" },
  { name: "Barbados", code: "Barbados" },
  { name: "Belarus", code: "Belarus" },
  { name: "Belgium", code: "Belgium" },
  { name: "Belize", code: "Belize" },
  { name: "Benin", code: "Benin" },
  { name: "Bhutan", code: "Bhutan" },
  { name: "Bolivia", code: "Bolivia" },
  { name: "Bosnia and Herzegovina", code: "Bosnia and Herzegovina" },
  { name: "Botswana", code: "Botswana" },
  { name: "Brazil", code: "Brazil" },
  { name: "Brunei", code: "Brunei" },
  { name: "Bulgaria", code: "Bulgaria" },
  { name: "Burkina Faso", code: "Burkina Faso" },
  { name: "Burundi", code: "Burundi" },
  { name: "Cabo Verde", code: "Cabo Verde" },
  { name: "Cambodia", code: "Cambodia" },
  { name: "Cameroon", code: "Cameroon" },
  { name: "Canada", code: "Canada" },
  { name: "Central African Republic", code: "Central African Republic" },
  { name: "Chad", code: "Chad" },
  { name: "Chile", code: "Chile" },
  { name: "China", code: "China" },
  { name: "Colombia", code: "Colombia" },
  { name: "Comoros", code: "Comoros" },
  { name: "Congo", code: "Congo" },
  { name: "Costa Rica", code: "Costa Rica" },
  { name: "Croatia", code: "Croatia" },
  { name: "Cuba", code: "Cuba" },
  { name: "Cyprus", code: "Cyprus" },
  { name: "Czech Republic", code: "Czech Republic" },
  { name: "Denmark", code: "Denmark" },
  { name: "Djibouti", code: "Djibouti" },
  { name: "Dominica", code: "Dominica" },
  { name: "Dominican Republic", code: "Dominican Republic" },
  { name: "Ecuador", code: "Ecuador" },
  { name: "Egypt", code: "Egypt" },
  { name: "El Salvador", code: "El Salvador" },
  { name: "Equatorial Guinea", code: "Equatorial Guinea" },
  { name: "Eritrea", code: "Eritrea" },
  { name: "Estonia", code: "Estonia" },
  { name: "Eswatini", code: "Eswatini" },
  { name: "Ethiopia", code: "Ethiopia" },
  { name: "Fiji", code: "Fiji" },
  { name: "Finland", code: "Finland" },
  { name: "France", code: "France" },
  { name: "Gabon", code: "Gabon" },
  { name: "Gambia", code: "Gambia" },
  { name: "Georgia", code: "Georgia" },
  { name: "Germany", code: "Germany" },
  { name: "Ghana", code: "Ghana" },
  { name: "Greece", code: "Greece" },
  { name: "Grenada", code: "Grenada" },
  { name: "Guatemala", code: "Guatemala" },
  { name: "Guinea", code: "Guinea" },
  { name: "Guinea-Bissau", code: "Guinea-Bissau" },
  { name: "Guyana", code: "Guyana" },
  { name: "Haiti", code: "Haiti" },
  { name: "Honduras", code: "Honduras" },
  { name: "Hungary", code: "Hungary" },
  { name: "Iceland", code: "Iceland" },
  { name: "India", code: "India" },
  { name: "Indonesia", code: "Indonesia" },
  { name: "Iran", code: "Iran" },
  { name: "Iraq", code: "Iraq" },
  { name: "Ireland", code: "Ireland" },
  { name: "Israel", code: "Israel" },
  { name: "Italy", code: "Italy" },
  { name: "Ivory Coast", code: "Ivory Coast" },
  { name: "Jamaica", code: "Jamaica" },
  { name: "Japan", code: "Japan" },
  { name: "Jordan", code: "Jordan" },
  { name: "Kazakhstan", code: "Kazakhstan" },
  { name: "Kenya", code: "Kenya" },
  { name: "Kiribati", code: "Kiribati" },
  { name: "Kuwait", code: "Kuwait" },
  { name: "Kyrgyzstan", code: "Kyrgyzstan" },
  { name: "Laos", code: "Laos" },
  { name: "Latvia", code: "Latvia" },
  { name: "Lebanon", code: "Lebanon" },
  { name: "Lesotho", code: "Lesotho" },
  { name: "Liberia", code: "Liberia" },
  { name: "Libya", code: "Libya" },
  { name: "Liechtenstein", code: "Liechtenstein" },
  { name: "Lithuania", code: "Lithuania" },
  { name: "Luxembourg", code: "Luxembourg" },
  { name: "Madagascar", code: "Madagascar" },
  { name: "Malawi", code: "Malawi" },
  { name: "Malaysia", code: "Malaysia" },
  { name: "Maldives", code: "Maldives" },
  { name: "Mali", code: "Mali" },
  { name: "Malta", code: "Malta" },
  { name: "Marshall Islands", code: "Marshall Islands" },
  { name: "Mauritania", code: "Mauritania" },
  { name: "Mauritius", code: "Mauritius" },
  { name: "Mexico", code: "Mexico" },
  { name: "Micronesia", code: "Micronesia" },
  { name: "Moldova", code: "Moldova" },
  { name: "Monaco", code: "Monaco" },
  { name: "Mongolia", code: "Mongolia" },
  { name: "Montenegro", code: "Montenegro" },
  { name: "Morocco", code: "Morocco" },
  { name: "Mozambique", code: "Mozambique" },
  { name: "Myanmar", code: "Myanmar" },
  { name: "Namibia", code: "Namibia" },
  { name: "Nauru", code: "Nauru" },
  { name: "Nepal", code: "Nepal" },
  { name: "Netherlands", code: "Netherlands" },
  { name: "New Zealand", code: "New Zealand" },
  { name: "Nicaragua", code: "Nicaragua" },
  { name: "Niger", code: "Niger" },
  { name: "Nigeria", code: "Nigeria" },
  { name: "North Korea", code: "North Korea" },
  { name: "North Macedonia", code: "North Macedonia" },
  { name: "Norway", code: "Norway" },
  { name: "Oman", code: "Oman" },
  { name: "Pakistan", code: "Pakistan" },
  { name: "Palau", code: "Palau" },
  { name: "Palestine", code: "Palestine" },
  { name: "Panama", code: "Panama" },
  { name: "Papua New Guinea", code: "Papua New Guinea" },
  { name: "Paraguay", code: "Paraguay" },
  { name: "Peru", code: "Peru" },
  { name: "Philippines", code: "Philippines" },
  { name: "Poland", code: "Poland" },
  { name: "Portugal", code: "Portugal" },
  { name: "Qatar", code: "Qatar" },
  { name: "Romania", code: "Romania" },
  { name: "Russia", code: "Russia" },
  { name: "Rwanda", code: "Rwanda" },
  { name: "Saint Kitts and Nevis", code: "Saint Kitts and Nevis" },
  { name: "Saint Lucia", code: "Saint Lucia" },
  { name: "Saint Vincent and the Grenadines", code: "Saint Vincent and the Grenadines" },
  { name: "Samoa", code: "Samoa" },
  { name: "San Marino", code: "San Marino" },
  { name: "Sao Tome and Principe", code: "Sao Tome and Principe" },
  { name: "Saudi Arabia", code: "Saudi Arabia" },
  { name: "Senegal", code: "Senegal" },
  { name: "Serbia", code: "Serbia" },
  { name: "Seychelles", code: "Seychelles" },
  { name: "Sierra Leone", code: "Sierra Leone" },
  { name: "Singapore", code: "Singapore" },
  { name: "Slovakia", code: "Slovakia" },
  { name: "Slovenia", code: "Slovenia" },
  { name: "Solomon Islands", code: "Solomon Islands" },
  { name: "Somalia", code: "Somalia" },
  { name: "South Africa", code: "South Africa" },
  { name: "South Korea", code: "South Korea" },
  { name: "South Sudan", code: "South Sudan" },
  { name: "Spain", code: "Spain" },
  { name: "Sri Lanka", code: "Sri Lanka" },
  { name: "Sudan", code: "Sudan" },
  { name: "Suriname", code: "Suriname" },
  { name: "Sweden", code: "Sweden" },
  { name: "Switzerland", code: "Switzerland" },
  { name: "Syria", code: "Syria" },
  { name: "Taiwan", code: "Taiwan" },
  { name: "Tajikistan", code: "Tajikistan" },
  { name: "Tanzania", code: "Tanzania" },
  { name: "Thailand", code: "Thailand" },
  { name: "Timor-Leste", code: "Timor-Leste" },
  { name: "Togo", code: "Togo" },
  { name: "Tonga", code: "Tonga" },
  { name: "Trinidad and Tobago", code: "Trinidad and Tobago" },
  { name: "Tunisia", code: "Tunisia" },
  { name: "Turkey", code: "Turkey" },
  { name: "Turkmenistan", code: "Turkmenistan" },
  { name: "Tuvalu", code: "Tuvalu" },
  { name: "Uganda", code: "Uganda" },
  { name: "Ukraine", code: "Ukraine" },
  { name: "United Arab Emirates", code: "United Arab Emirates" },
  { name: "United Kingdom", code: "United Kingdom" },
  { name: "United States", code: "United States" },
  { name: "Uruguay", code: "Uruguay" },
  { name: "Uzbekistan", code: "Uzbekistan" },
  { name: "Vanuatu", code: "Vanuatu" },
  { name: "Vatican City", code: "Vatican City" },
  { name: "Venezuela", code: "Venezuela" },
  { name: "Vietnam", code: "Vietnam" },
  { name: "Yemen", code: "Yemen" },
  { name: "Zambia", code: "Zambia" },
  { name: "Zimbabwe", code: "Zimbabwe" }
]

export default Country
